"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotFullyDefinedCustomer = void 0;
const allRequiredFields = [
    'name',
    'firstname',
    'email',
    'phone',
    'address1',
    'codePostal',
    'city',
    'country',
    'lang',
];
const isNotFullyDefinedCustomer = (customer) => {
    if (!customer) {
        return true;
    }
    return allRequiredFields.some((field) => !customer[field] || customer[field].trim().length === 0);
};
exports.isNotFullyDefinedCustomer = isNotFullyDefinedCustomer;
//# sourceMappingURL=isNotFullyDefinedCustomer.js.map